import React, { Component } from "react";
import "./ChangePassword.css";
import MMCL_Logo from "../static/images/MMCL_Logo.webp";
import { toast } from "react-toastify";
import PasswordRegCheck from './custom_validations/PasswordRegCheck.js';
import axios from "../api/axios.js";
import hideElements from '../utility/Tools.js';

async function changePassword(){
  var ForgetPass_url="changepassword";
  var pwd = document.getElementById('inputConfirmPassword').value
  if (window.location.href.indexOf("code") > -1){
    let paramString = new URL(document.location).searchParams;
    let token = paramString.get("code");
    localStorage.setItem("token",token);
  }
  try{
      toast.success('You have changed your password!', {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
      });
    axios.patch(ForgetPass_url,JSON.stringify({pwd }),
      {
          headers: { 
              "Authorization": 'bearer '+localStorage.getItem("token"),
              "Content-Type": "application/json"
           },
      });
    //put success message
      hideElements();
      document.getElementById("changePasswordHeader").innerText = "Password Change Successful";
      document.getElementById("changePasswordText").innerText = "You will now be redirected to the Sign In page.";
    setTimeout(function () {
    if (window.location.href.indexOf("code") > -1)
      window.location.href = '/sign-in';
    else
    window.location.href = '/ApplicantStatus';
    },5000)
  }catch(err){
    alert('error');
  }
}

export class ChangePassword extends Component {
  static displayName = ChangePassword.name;

  componentDidMount(){
    document.getElementById("inputPassword").addEventListener("keypress", function(event){
      if(event.key==="Enter"){
        event.preventDefault();
        document.getElementById("btnChangePass").click();
      }
  })
  document.getElementById("inputConfirmPassword").addEventListener("keypress",function(event){
    if(event.key==="Enter"){
        event.preventDefault();
        document.getElementById("btnChangePass").click();
    }
})
}

  render() {
    return (
      <div className="change-password">
        <div className="card change-password-card">
          <form>
            <div className="change-password-container text-center">
              <img src={MMCL_Logo} className="change-password-logo" alt="MMCL Logo" />
            </div>
            <h3 id="changePasswordHeader" className="text-center mt-10 b-10">CHANGE PASSWORD</h3>
            <p id="changePasswordText" class="text-center mt-5 mb-5"></p>
            <div className="form-outline mb-4 hiding-elements">
                <label className="form-label" for="inputPassword">New Password</label>
                <input type="password" id="inputPassword" className="form-control" onChange={PasswordRegCheck} />
            </div>
            <div className="form-outline mb-4 hiding-elements">
                <label className="form-label" for="inputConfirmPassword">Confirm Password</label>
                <input type="password" id="inputConfirmPassword" className="form-control" onChange={PasswordRegCheck}/>
            </div>
            <div id="passRequirements" style={{ display: "none" }} className="change-password-pass-requirement hiding-elements">
                <li id="passLength">✕ Password must be at least 8 characters.</li>
                <li id="passUpperAndLower">✕ Password must be a combination of uppercase and lowercase letters.</li>
                <li id="passLettersAndNumbers">✕ Password must be a combination of letters and numbers.</li>
                <li id="passSpecialCharacters">✕ Password must have atleast one (1) special character (# ? ! + &).</li>
                <li id="passMatchPassword">✕ Password must match.</li>   
                <br/>
            </div>
            <div className="text-center hiding-elements">
                <button id="btnChangePass" type="button" className="btn btn-block mb-4 sign-up-button" onClick={() => changePassword()}>Submit</button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
